import { FormLabel, FormLabelProps } from '@mui/material'
import React from 'react'

export type WcFormLabelProps = FormLabelProps;

export const WcFormLabel = ({children, ...props}: WcFormLabelProps) => (
    <FormLabel {...props}>{children}</FormLabel>
  )